module.exports = __webpack_public_path__ + "img/ios4.57b21bc0.png";